import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '../../../../contexts/ThemeContext';

const OffensivePlayVolumeChart = ({ teamData, leagueData, teamName }) => {
	const { isDarkMode } = useTheme();
	const chartTextColor = isDarkMode ? '#E5E7EB' : '#374151';

	// Extract the last word from the team name
	const teamNameLastWord = teamName.split(' ').pop();

	// Ensure data exists and provide fallbacks, converting values to numbers
	const teamPassAttempts =
		(teamData && teamData.avg_pass_attempts) || teamData.pass_attempts
			? parseFloat(teamData.avg_pass_attempts || teamData.pass_attempts)
			: 0;
	const teamRushAttempts =
		(teamData && teamData.avg_rush_attempts) || teamData.rush_attempts
			? parseFloat(teamData.avg_rush_attempts || teamData.rush_attempts)
			: 0;
	const leaguePassAttempts =
		leagueData && leagueData.avg_pass_attempts
			? parseFloat(leagueData.avg_pass_attempts)
			: 0;
	const leagueRushAttempts =
		leagueData && leagueData.avg_rush_attempts
			? parseFloat(leagueData.avg_rush_attempts)
			: 0;

	// Chart configuration
	const chartOptions = {
		series: [
			{
				name: 'Passing Plays',
				data: [
					teamPassAttempts,
					leaguePassAttempts
				]
			},
			{
				name: 'Rushing Plays',
				data: [
					teamRushAttempts,
					leagueRushAttempts
				]
			}
		],
		options: {
			chart: {
				type: 'bar',
				stacked: true,
				height: 250,
				foreColor: chartTextColor
			},
			plotOptions: {
				bar: {
					horizontal: true,
					barHeight: '55%'
				}
			},
			colors: [
				'#9647B8',
				'#15997E'
			],
			stroke: {
				width: 1,
				colors: [
					'#fff'
				]
			},
			title: {
				text: 'Play Volume',
				align: 'center',
				style: { fontSize: '14px' }
			},
			xaxis: {
				title: {
					text: '# of Plays'
				},
				categories: [
					`${teamNameLastWord}`,
					'League Avg'
				],
				labels: {
					formatter: (val) => `${Math.round(val)}` // No decimal, rounding to nearest whole number
				}
			},
			tooltip: {
				y: {
					formatter: (val) => `${Math.round(val)}` // No decimal in the tooltip as well
				}
			},
			fill: {
				opacity: 1
			},
			legend: {
				position: 'top',
				horizontalAlign: 'center'
			}
		}
	};

	return (
		<div className="bg-white dark:bg-dark-card p-4 rounded-lg shadow-lg border border-gray-300 dark:border-dark-border">
			<ReactApexChart
				options={chartOptions.options}
				series={chartOptions.series}
				type="bar"
				height={250}
			/>
		</div>
	);
};

export default OffensivePlayVolumeChart;
